import React, { useEffect } from 'react';
import { FiCheckCircle, FiX } from 'react-icons/fi';

/**
 * Toast (popup flutuante) para avisos rápidos, ex.: "item adicionado ao carrinho".
 * Aparece na base da tela e some sozinho após `duration` ms.
 */
export default function Toast({ message, onClose, duration = 3500 }) {
  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(onClose, duration);
    return () => clearTimeout(t);
  }, [message, duration, onClose]);

  if (!message) return null;

  // Remove emoji/símbolo no início da mensagem (o ícone já indica sucesso).
  const text = String(message).replace(/^[^\p{L}\p{N}]+/u, '');

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 28,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10001,
        width: 'calc(100% - 32px)',
        maxWidth: 460,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '14px 16px',
        background: '#14241a',
        border: '1px solid #22c55e',
        borderRadius: 12,
        boxShadow: '0 12px 32px rgba(0, 0, 0, 0.45)',
        color: '#eafff1',
        fontSize: 14,
        lineHeight: 1.4,
        animation: 'toast-in 0.25s ease-out',
      }}
    >
      <FiCheckCircle style={{ color: '#22c55e', flexShrink: 0, fontSize: 20 }} />
      <span style={{ flex: 1 }}>{text}</span>
      <button
        type="button"
        aria-label="Fechar"
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#9fb3a6',
          cursor: 'pointer',
          fontSize: 18,
          lineHeight: 1,
          display: 'inline-flex',
          flexShrink: 0,
        }}
      >
        <FiX />
      </button>

      <style>{`
        @keyframes toast-in {
          from { opacity: 0; transform: translate(-50%, 12px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
}
